import React from "react";

const WasteWaterTreatment = () => {
  return <div>Waste Water Treatment Page</div>;
};

export default WasteWaterTreatment;
